import { render } from "./Logo.vue?vue&type=template&id=1be00aee&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=1be00aee&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be00aee"]])

export default __exports__